module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._l((_vm.relatedModules), function(item) {
    return [_c('a', {
      attrs: {
        "href": _vm.getUrl(item),
        "target": "_blank"
      }
    }, [(item.title) ? _c('span', {
      directives: [{
        name: "popover",
        rawName: "v-popover:tooltip",
        value: (_vm.t(item.title)),
        expression: "t(item.title)",
        arg: "tooltip"
      }],
      class: _vm.getIconClass(item)
    }) : _c('span', {
      class: _vm.getIconClass(item)
    })])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fc39eba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/RelatedModulesComponent.vue
// module id = 1307
// module chunks = 2